import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import MuiFormControl from "@mui/material/FormControl";
import classNames from "classnames";
export const FormControl = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    id,
    className,
    disabled,
    children,
    ...otherProps
  } = props;
  return /*#__PURE__*/React.createElement(MuiFormControl, _extends({
    id: id ? `${id}-form-control` : undefined,
    ref: ref,
    className: classNames("prmbl-formControl", className),
    disabled: disabled,
    "aria-disabled": disabled,
    margin: "normal"
  }, otherProps), children);
});
FormControl.displayName = "FormControl";
export default FormControl;